import type { ISupportingDocumentTypes } from 'types/kinerja-pelaksanaan'

export const REQUIRED_SUPPORTING_DOCUMENT_TYPES: Array<{
  type: ISupportingDocumentTypes
  label: string
}> = [
  { type: 'KOSP', label: 'Dokumen KOSP' },
  { type: 'PLANNING', label: 'Dokumen Perencanaan Satuan Pendidikan' },
  { type: 'REPORT', label: 'Dokumen Laporan Satuan Pendidikan' },
  { type: 'ATTENDANCE', label: 'Rangkuman Kehadiran Guru' },
]
